import { Map as map } from 'immutable';
const C = require("../constants");

function IngredientSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.INGREDIENT_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default IngredientSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/IngredientSelectReducer.js